import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const CloseIcon = ({ size = 22, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
)
